// ZERCODE CHANGE [STD-FE]: Berry's useAuth read its JWTContext (axios-based).
// Auth now lives in @zercode/auth (Identity :5101, TanStack Query + Zustand,
// memory-only tokens). This adapter keeps Berry's hook contract
// ({ user, logout, isLoggedIn }) so components like Header/ProfileSection
// stay untouched. While authenticated, the user is refreshed from Identity's
// `me` endpoint (useMe → TanStack Query); the login response user is the
// fallback until that query resolves.
import { useMe, useSessionStore } from '@zercode/auth';

import { authApi } from '../../lib/zercode';

export default function useAuth() {
  const sessionUser = useSessionStore((s) => s.user);
  const status = useSessionStore((s) => s.status);

  // fresh name/email from Identity `me` — query enabled only while authenticated
  const me = useMe(authApi);
  const user = me.data ?? sessionUser;

  return {
    isLoggedIn: status === 'authenticated',
    user: user
      ? {
          id: user.id,
          email: user.email,
          name: user.displayName ?? user.email,
          // AVATAR-UPLOAD (mig 309): PRESENCE, not a URL. The picture is authenticated bytes now, so the
          // header fetches them itself (useMyAvatarUrl) — the legacy avatarUrl is retired.
          hasAvatar: user.hasAvatar ?? false
        }
      : null,
    logout: () => authApi.logout()
  };
}
